.model_select {
  min-width: 220px;
}
